import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import "react-datepicker/dist/react-datepicker.css";
registerLocale("ru", ru);

function DPicker({handleDateSelection}) {
  const today = new Date();
  today.setDate(today.getDate() - 1);
  const [startDate, setStartDate] = useState(new Date(today));
  const [endDate, setEndDate] = useState(new Date());
  const onChange = dates => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  useEffect(() => {
    if (startDate != null && endDate != null) {

      handleDateSelection([(endDate-startDate)/86400000,startDate,endDate]);
    }
    //eslint-disable-next-line
  }, [endDate]);
  return (
    <div>
      <DatePicker
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        inline
        locale="ru"
      />
      {/* <p>
        с {startDate && startDate.toLocaleDateString()} по{" "}
        {endDate && endDate.toLocaleDateString()}
      </p> */}
    </div>
  );
}

export default DPicker;
